import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddAirline, AddNewHotel, getAirlineList, getHotelList, getSuggestList, updateAirlineStatus, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";

import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import debounce from "lodash.debounce";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";



const airlinefilterData = {
    code:null,
    active:null,
    name:null,

}

const AirlineList = () => {
    const [airlineList,setAirLineList] = useState([]); 
    const [hoteldata,setHotelData] =  useState(airlinefilterData );
  //  const [cityData,setCityData] =  useState(hotelfilterData);
    const [totalPages, setTotalPages] = useState(null);
    const [totalElements, setTotalElements] = useState("");
    const [currPage, setCurrPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showHotel,SetShowHotel] = useState(false);
    const [newHotelData, setNewHotelData] = useState({
      code: null,
      name:null,
      active: null,
     
  });
  const [errors, setErrors] = useState({});
  const[loading,setLoading] = useState(false);

    const navigate = useNavigate();

    const handleViewCity = (cityId) => {
      navigate(`/flight/view/airline/${cityId}`); // Navigate to the city details page
    };
    const handleModalInputChange = (e) => {
      const { name, value } = e.target;
      setNewHotelData((prev) => ({
          ...prev,
          [name]: value,
      }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newHotelData.code) {
      newErrors.code = "Airline Code is required";
    }
    if (!newHotelData.name) {
      newErrors.name = "Airline Name is required";
    }
    if (newHotelData.active === "") {
      newErrors.active = "Status is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

    const fetchSuggestions = debounce((query, identifier,type) => {
      getSuggestList(query, identifier,type)
        .then((resp) => {
          console.log("API Response:", resp?.data.data.suggestions); // Debug response
          if (resp?.data.data.suggestions) {
            setSuggestions([...resp?.data.data.suggestions]);
            setShowSuggestions(true);
           
          } else {
            setSuggestions([]);
            setShowSuggestions(false); // Handle no suggestions case
            
          }
        })
        .catch((error) => console.error("Error fetching suggestions:", error));
    }, 300);

    const handleDetailData = (e) => {
        const { name, value } = e.target;
        setHotelData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "hotelName" && value.trim()) {
          fetchSuggestions(value, "loc","2"); // Fetch suggestions only when there's a value
        } else{
          setSuggestions([]);
          setShowSuggestions(false);
  
        }
    };

const showHotelList = (page,key = "")=>{
console.log("setDetailData",hoteldata)
let param = {
    page:page,
    code:hoteldata?.code,
    name:hoteldata?.name,
   
 //   countryCode:"",
  //  cityId:"",
    active:hoteldata?.active
   
}

if(key === "refresh"){
    param.hotelCode = "";

   setHotelData(airlinefilterData);

}

     setLoading(true);
    getAirlineList(param).then((resp)=>{
      
         setLoading(false);
        if(resp){
            
          setAirLineList(resp?.data?.data?.airline?.content);
            setTotalPages(resp?.data?.data?.airline?.totalPages)
        
        }
    


    })
}

const currPageSet = (currentPage) =>{
    showHotelList(currentPage)
setCurrPage(currentPage);
}






useEffect(()=>{
showHotelList(currPage);
},[])


const handleAddHotel = ()=>{
  
  SetShowHotel((prev) => prev ? false: true);

}

const handleSubmit = ()=>{
  
  if (!validateForm()) {
    return; 
  }

if(newHotelData.active ==="true"){
  newHotelData.active = true
} else{
  newHotelData.active = false;
}
 
  AddAirline(newHotelData).then((resp)=>{

  if(resp){
    SetShowHotel(false);
    showHotelList(currPage);

  }

  })
}

const updateStatus =(id)=>{
updateAirlineStatus(id).then((res)=>{
 if(res){
  showHotelList(currPage);
 }

})

}


    return(
        <>
         <div className="userlisthead_container">
         <div style={{ padding: "30px" }}>
         <div className="transaction_main_container">
         <div className="userlist_head">
            <div className="userlist_heading mb-5">
              <div className="userlist_left">
                <label>Airline List</label>
              </div>
              <button onClick={()=>navigate('/flight/addAirline')} className="userlist_btn">Add New Airline</button>    

           
            </div>
          </div>
         
               <FilterWrapper>
          <div className="filterBox">
              <div style={{width:"100%"}}>
                <div className="flex align-items gap-20">
                <div style={{position:"relative"}}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Airline Name"
                     value={hoteldata?.name}
                     onChange={handleDetailData}
                      maxLength={20}
                     // onKeyDown={handleKeyDown}
                    />
                    { showSuggestions && suggestions.length > 0 && (
  <AutoSuggestion
    fromCityList={suggestions}
    setCityName={(name) =>
      setHotelData((prev) => ({
        ...prev,
        hotelName: name,
      }))
    }
    setCityId={(id) =>
      setHotelData((prev) => ({
        ...prev,
        id: id, // Set the selected city ID
      }))
    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />
)}
                  </div>
                <div>
                    <input
                      type="text"
                      name="code"
                      placeholder="Airline Code"
                     value={hoteldata?.code}
                     onChange={handleDetailData}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                
                
                  <div className="input-field">
                    <select
                      className="input_select_field"
                      name="active"
                     value={hoteldata?.active}
                      onChange={handleDetailData}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="" selected={hoteldata?.active === null}>Select status</option> 
                     <>
                      <option value={"true"}>ACTIVE</option>
                     <option value={"false"}>INACTIVE</option>
                      </>
                    </select>
                  </div>
                 
                 
                 
                 
                 
                  {/* <div>
                    <input
                      type="text"
                      name="cityId"
                      placeholder="City Id"
                      value={hoteldata?.cityId}
                     // onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="feedSource"
                      placeholder="Feed Source"
                      value={hoteldata?.feedSource}
                     // onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div> */}

                 
                 
                  <div className="button">
                    <button
                      className="userlist_btn"
                      onClick={(e) => showHotelList(0, "search")}
                    >
                      Search
                    </button>
                  </div>

                  <div className="button">
                    <button
                      className="refresh-btn"
                      onClick={(e) => showHotelList(0, "refresh")}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

              </FilterWrapper>
          </div>

          <div className="table-loader">
          {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                   <th>AIRLINE CODE</th>
                    <th>AIRLINE NAME</th>
                    <th>LAST UPDATE</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                   
                   
                  </tr>
                </thead>
                <tbody>
                    {airlineList && 
                    airlineList?.map((items)=>{
                          const dateTimeString = items?.lastUpdatedAt;
                           let [date, time] = dateTimeString.split("T");
                           let newTime = time.slice(0, 8);
                        return(
                         <>
                            <tr>
                            <td>{items?.code}</td>
                            <td>{items?.name}</td>
                            <td>{date + " " + newTime}</td>
                            <td>
                            <div
                                    className={`custom-toggle toggle_button ${
                                      items.active === true ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      updateStatus(items.id, items.active)
                                    }
                                    styled={{
                                      margin: "0",
                                      marginRight: "12px",
                                    }}
                                  >
                                    <div className="slider"></div>
                                  </div>
                            </td>


                            <td className="user_action_btn button">
                  <span>
                    <button onClick={() => handleViewCity(items?.id)}>
                    <i class="fa-solid fa-pen-to-square update" aria-hidden="true"></i>

                    </button>
                  </span>
                            </td>
                             </tr>
                         </>


                        )
                      

                    })
                    
                    
                    }

                </tbody>
              </table>
            </TableWrapper>
            </div>
            
            {totalPages > 1 && (
        <Pagination
         items={showHotelList}
          itemsPerPage={pageSize}
          setitemsPerPage={setPageSize}
          currentPage={currPage}
          setcurrentPage={(page)=>currPageSet(page)}
          totalPages={totalPages}
          forcePage={currPage}
        />
      )}
   
            
            
            </div>
        
        
       
        
         </div>
     
        
        
        
        </>
    )

}

export default AirlineList;